import types from '../types/revoke'
import {Map} from 'immutable'

const initialRoot = Map({
  open: false,
  accessId: 0,
  name: '',
  isSaving: false,
  error: '',
})

function root(state = initialRoot, action) {
  switch (action.type) {
    case types.SET_OPEN:
      return state.merge({
        open: action.payload.open,
        accessId: action.payload.accessId,
        name: action.payload.name !== '' ? action.payload.name : state.get('name'), //prevent flash of empty name while closing
      })
    case types.REVOKE_ACCESS:
      return state.merge({
        isSaving: true,
        error: '',
      })
    case types.REVOKE_ACCESS_SUCCESS:
      return state.merge({
        open: false,
        isSaving: false,
        error: '',
      })
    case types.REVOKE_ACCESS_FAIL:
      return state.merge({
        isSaving: false,
        error: action.payload.error,
      })
    default:
      return state
  }
}

export default root



// WEBPACK FOOTER //
// ./src/sections/shared/reducers/revoke.js